
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanFlag as ObiBuoyCanFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-flag.js';
 
 
 

 
 export const ObiBuoyCanFlag = createComponent({
   react: React,
   tagName: 'obi-buoy-can-flag',
   elementClass: ObiBuoyCanFlagElement,
   events: {
     
   }
  });
 
 